import { featuresSelector } from '@/support/Selectors';
import { ErrorMessage } from '@hookform/error-message';
import { createSelector } from '@reduxjs/toolkit';
import type { FC } from 'react';
//@ts-expect-error - old hook form - replace with `react-hook-form@latest`
import { Controller, ControllerRenderProps, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

interface ReasonForChangeProps {
  isDelete?: boolean;
}

const featureSelector = createSelector([featuresSelector], (features) => ({
  reasonForChange: features?.reason_for_change ?? false,
}));

const ReasonForChange: FC<ReasonForChangeProps> = ({ isDelete }) => {
  const { reasonForChange } = useSelector(featureSelector);

  const { errors, control } = useFormContext();

  return (
    <>
      {reasonForChange && (
        <div className="pt2" data-testid="reason-for-change-container">
          <label htmlFor="reason_for_change" data-testid="reason-for-label">
            Reason for {isDelete ? 'deletion' : 'change'} <span className="blue">*</span>
          </label>
          <Controller
            name="reason_for_change"
            control={control}
            rules={{
              required: `You must provide a reason for the ${isDelete ? 'deletion' : 'change'}`,
              minLength: {
                value: 3,
                message: 'Please enter at least 3 characters',
              },
              maxLength: {
                value: 255,
                message: 'Please enter less than 256 characters',
              },
            }}
            render={({ value, onChange }: ControllerRenderProps) => (
              <textarea
                defaultValue={value}
                onChange={onChange}
                id="reason_for_change"
                style={{ resize: 'none' }}
                className={`${errors.reason_for_change ? 'input__error' : ''} mb0`}
                data-testid="reason-for-change-field"
              />
            )}
          />
          <ErrorMessage
            errors={errors}
            name={`reason_for_change`}
            render={({ message }) => <p className="f6 red db lh-copy pt1">{message}</p>}
          />
        </div>
      )}
    </>
  );
};

export default ReasonForChange;
